import _ from "lodash";
import config from "../LevelsShow/config";
function randomnum(){
  return Math.floor(Math.random() * 10000);
}
let meshTypes = [
  { type: "ground", id: 60009 },
  { type: "product1", id: 3 },
  { type: "product2", id: 4 },
  { type: "product3", id: 1 },
  { type: "product4", id: 2 },
  { type: "product5", id: 120009 },
  { type: "product6", id: 90010 },
  { type: "product4", id: 240009 },
  { type: "水泥台", id: 90009 },
  { type: "tower", id: 150009 },
  { type: "wind", id: 150011 },
  { type: "light", id: 7 },
  { type: "park", id: 150010 },
  { type: "powerBox", id: 6 },
  { type: "electricalBox", id: 5 },
  {type:"dryandwet",id:210010},
  {type:"powerBox",id:270009}
];
// {
//   "batteryBox": [
//     {
//       "batteryBoxId": 1,
//       "batteryBoxName": "1#插箱",
//       "isShow": true
//     },
//     {
//       "batteryBoxId": 2,
//       "batteryBoxName": "2#插箱",
//       "isShow": true
//     },
//     {
//       "batteryBoxId": 3,
//       "batteryBoxName": "3#插箱",
//       "isShow": true
//     }
//   ],
//   "cluId": 1,
//   "cluName": "1#簇",
//   "isShow": true
// }

function gencu(id,name,show,batterynum) {
  let batteryBox = []
  for (let index = 0; index < batterynum; index++) {
    batteryBox.push({
      batteryBoxId:   randomnum() + (index + 1)+ "#插箱",
      batteryBoxName: randomnum() + (index + 1) + "#插箱",
      isShow: !(randomnum()>5000)
    })
  }
  return {
    batteryBox:batteryBox,
    cluId: id,
    cluName: name,
    isShow:show
  };
}

function gencusinfo(type) {
  let cus = []
  if (type.indexOf("product") === 0) {
    let productcfg = config[type].cu
    let cunum = productcfg.num *(productcfg.bigcu.length)
    for (let index = 0; index < cunum; index++) {
      let id = randomnum() + (index + 1)+ "#簇"
      let name = randomnum() + (index + 1)+ "#簇"
      let show = !(randomnum()>5000)
      let batterynum = productcfg.row*productcfg.height
      let cu = gencu(id,name,show,batterynum)
      cus.push(cu)
    }
  }
  return cus
}
//添加数据结构
export function transProjectInfo(treedata) {
  // console.log(treedata);
  let arrdata = [];
  // 场景配置
  arrdata.push({
    id: 0,
    level: 0,
    pid: null,
    meta: {
      name: "projectScene",
      id: "projectId",
      meshType: null,
      width: null,
      depth: null,
      x: 0,
      z: 0,
      ispicker: true,
      rotation: 0
    }
  });
  let level = 1;
  genlayout(arrdata, treedata, level, 0);
  // children
  return arrdata;
}
// {id: 71, level: 2,pid: 64,data:gendata(),meta: {  name: "electricalBox_1",  id: "electricalBox_1",  meshType: 'electricalBox',  width: 28.1,  depth: 14.6,  x: -36.7339,  z: -13.8774 - 16*5 ,  ispicker:true,rotation: 0}},

export function unTransProjectInfo(arrdata) {
  // console.log(arrdata);
  let treedata = [];
  let level1s = [];
  for (let index = 0; index < arrdata.length; index++) {
    const item = arrdata[index];
    if (item.level === 1) {
      // console.log(item);
      let node = {
        cellClustersBoxs: { cellClusters: [] },
        children: [],
        equipId: item.meta.id,
        // equipModelId: meshTypes.indexOf(item.meta.meshType),
        equipModelId: _.find(meshTypes,{type:item.meta.meshType}).id,
        equipName: item.meta.name,
        groupSize: `${item.meta.width},${item.meta.depth}`,
        position: `${item.meta.x},${item.meta.z},${item.meta.rotation}`,
        projectId: "86-071000-001",
        showLevel: 1,
        showOrder: item.id
      };
      treedata.push(node);
      level1s.push(node);
    }
  }
  for (let index = 0; index < arrdata.length; index++) {
    const item = arrdata[index];
    if (item.level === 2) {
      let level1node = _.find(level1s, o => {
        return o.showOrder == item.pid;
      });

      let cus = gencusinfo(item.meta.meshType);
      let node = {
        cellClustersBoxs: { cellClusters: cus },
        children: [],
        equipId: item.meta.id,
        equipModelId:_.find(meshTypes,{type:item.meta.meshType}).id,
        equipName: item.meta.name,
        groupSize: `${item.meta.width},${item.meta.depth}`,
        position: `${item.meta.x},${item.meta.z},${item.meta.rotation}`,
        projectId: "86-071000-001",
        showLevel: 2,
        showOrder: item.id
      };
      level1node.children.push(node);
    }
  }
  // console.log(JSON.stringify(treedata));
  return treedata;
}

// cellClustersBoxs: {cellClusters: Array(1)}
// children: [{…}]
// equipId: 1
// equipModelId: 1
// equipName: "测试设备"
// groupSize: "20,20"
// position: "10,20,10"
// projectId: "86-071000-001"
// showLevel: 1
// showOrder: 1

function genlayout(resarr, childarr, childlevel, pid) {
  for (let i = 0; i < childarr.length; i++) {
    const item = childarr[i];
    let id = pid + "_" + i;
    let size = [null, null];
    try {
      size = item.groupSize.split(",");
    } catch (error) {}
    let poi = [null, null, null];
    try {
      poi = item.position.split(",");
    } catch (error) {}
    let cus = [];
    let models = [];
    // console.log(_.find(meshTypes,{id:item.equipModelId}).type, item.equipModelId);

    try {
      if (_.find(meshTypes,{id:item.equipModelId}).type.indexOf("product") === 0) {

        //属于产品 里面有簇 插槽等
        //cellClustersBoxs productin
        for (let j = 0; j < item.cellClustersBoxs.cellClusters.length; j++) {
          let cu = item.cellClustersBoxs.cellClusters[j];
          cus.push({ id: cu.cluId, name: cu.cluName, show: cu.isShow });


          for (let k = 0; k < cu.batteryBox.length; k++) {
            let model = cu.batteryBox[k];
            models.push({ id: model.batteryBoxId, name: model.batteryBoxName, show: model.isShow,cu });
          }
        }
      }
      if (_.find(meshTypes,{id:item.equipModelId}).type === "powerBox") {
        //属于功率仓 里面有pcs
      }
    } catch (error) {}
    resarr.push({
      id,
      level: childlevel,
      pid,
      meta: {
        cus,
        models,
        name: item.equipName,
        id: "id_" + item.equipId,
        meshType: _.find(meshTypes,{id:item.equipModelId}).type,
        width: parseFloat(size[0]),
        depth: parseFloat(size[1]),
        x: parseFloat(poi[0]),
        z: parseFloat(poi[1]),
        ispicker: true,
        rotation: parseInt(poi[2]),
        sn:item.sn,
        stackNum:item.stackNum,
        projectId:item.projectId
      }
    });
    if (item.children) {
      genlayout(resarr, item.children, childlevel + 1, id);
    }
  }
  return 1;
}



// WEBPACK FOOTER //
// ./src/components/webgl/mock/apifilter.js